/**
 * We already have a search service, this service is called Solr, since it access solr through the PL
 * though we are not accessing Solr here directly.
 */
angular.module('cfn').factory('SolrService', ['$http', '$q', SolrService]);

function SolrService($http, $q) {
  var SOLR_BASE_URL = '/365FarmNet/rest/search',
    INVALID_URL_PATH = '/invalid',
    DEFAULT_ROWS = 20,
    MAP_URL_TYPES = _.object(
      _.map(
        [
          'field',
          'plantProtectant',
          'cropSequence',
          'seed',
          'fertilizer',
          'person',
          'machine'
        ],
        function(item) {
          return [item.toLowerCase(), item];
        }
      )
    );

  function typeToUrl(type) {
    if (angular.isString(type)) {
      var urlType = MAP_URL_TYPES[type.toLowerCase()];
      if (urlType) return urlType;
    }
    return type;
  }

  /**
   *
   * @param path PL search path
   * @param options optional
   * @returns {string} the url to access solr
   */
  function buildUrl(path, options) {
    var url = SOLR_BASE_URL + path;
    if (options) {
      url +=
        '?' +
        Object.keys(options)
          .reduce(function(a, k) {
            a.push(k + '=' + encodeURIComponent(options[k]));
            return a;
          }, [])
          .join('&');
    }
    return url;
  }

  /**
   *
   * @param url solr service url
   * @param onSuccess function to be called in case of success (optional)
   * @param onError function to be called in case of error (optional)
   * @returns {*} a promise with the results.
   */
  function getSolrPromise(url, onSuccess, onError) {
    var noop = function(response) {
      return response;
    };

    var defer = $q.defer();
    $http.get(url).then(
      function(response) {
        defer.resolve((onSuccess || noop)(response.data));
      },
      function(response) {
        defer.reject((onError || noop)(response.data));
      }
    );

    return defer.promise;
  }

  return {
    getInvalid: function(maxRows) {
      return getSolrPromise(
        buildUrl(INVALID_URL_PATH, { rows: maxRows || DEFAULT_ROWS }),
        function(response) {
          angular.forEach(response.docs, function(doc) {
            if (!doc.icon) {
              if (doc.context === 'booking') {
                doc.icon = 'booking';
              } else if (doc.type) {
                doc.icon = doc.type.toLowerCase();
              }
            }
            if (!doc.url) {
              doc.url =
                '/' + doc.context + '/' + typeToUrl(doc.type) + '/' + doc.id;
            }
          });
          return response.docs;
        }
      );
    }
  };
}

export default SolrService;
